import { Component } from '@angular/core';
import { AppSettings } from './app.settings';
import { Settings } from './app.settings.model';
import { Router, NavigationEnd } from '@angular/router';
import { timeout } from 'rxjs/operators';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public settings: Settings;
  constructor(public appSettings: AppSettings, private router: Router) {
    this.settings = this.appSettings.settings;

    // * Google Analytics
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'UA-168661400-14', {
          page_path: event.urlAfterRedirects,
        });
      }
    });
    
  }

  ngOnInit() { 
  }

  ngAfterViewInit(): void{
    this.setValue();
  }

  language: any;
  // onLanguageChange() {
  //   console.log(this.language);
  //   var selLanguage = this.language;
  //   localStorage.setItem('language', selLanguage);
  // }
  setValue() {
    setTimeout(function(){ 
      var selLang = localStorage.getItem("language");
      var languageSelect = document.querySelector("select.goog-te-combo");
      if(selLang && languageSelect){
        (languageSelect as HTMLInputElement).value = selLang;
        languageSelect.dispatchEvent(new Event("change"));
      }
    }, 1000);
  }
}

('use strict');

export const sitekey = '6LeN83YaAAAAANFZopY1xbTsbYbgzjhYc-5LQai3'; // Local site key
// export const sitekey = '6LcxaosaAAAAAGed-Rb72J6YUuXmDb4vOskm6f5-';// QA site key

// export const baseUrl = 'http://localhost:8000/api';               //localhost
// export const baseFileUrlNew = 'http://localhost:8000'; // localhost
// export const baseFileUrl = 'http://localhost:8000/files'; // localhost

// export const baseFileUrl = 'https://test-slaapi.aicte-india.org/files'; // Dev
// export const baseUrl = 'https://test-slaapi.aicte-india.org/api'; // Dev
// export const baseFileUrlNew = 'https://test-slaapi.aicte-india.org'; // Dev

// export const baseFileUrl = 'https://qa-slaapi.aicte-india.org/files'; //QA
// export const baseUrl = 'https://qa-slaapi.aicte-india.org/api'; //QA
// export const baseFileUrlNew = 'https://qa-slaapi.aicte-india.org'; //QA

// export const baseFileUrl = 'https://aslapapi.aicte-india.org/files'; // Prod 
// export const baseUrl = 'https://aslapapi.aicte-india.org/api'; // Prod 
// export const baseFileUrlNew = 'https://aslapapi.aicte-india.org'; // Prod

//prod build

// new url
export const baseFileUrl = 'https://aslapapi.aicte.gov.in/files'; //Prod
export const baseUrl = 'https://aslapapi.aicte.gov.in/api'; //Prod
export const baseFileUrlNew = 'https://aslapapi.aicte.gov.in';//Prod

// Encryption Key for - Crypto JS
export const encryptionKey = 'd4P3GiX8fTjYjKiku0MEzQs7PmpaatSzvVKHS2';
